import { useTranslation } from "react-i18next";
import { Box, Card, Divider, Typography } from "@mui/material";
import { numberWithCommas } from "../../../utils/utility";

//import images and icons
import { Edit2 } from "iconsax-react";
import BusImage from "../../../assets/imgs/bus-default.jpg";

export function TicketPreview({ ticket, onEditTicket }) {
    const { t } = useTranslation();

    return (
        <Card variant="outlined" sx={{ p: { xs: 1.5, sm: 2.5, md: 3 }, borderRadius: 3 }}>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    alignItems: { xs: "stretch", md: "center" },
                    gap: { xs: 1.5, md: 2 },
                }}
            >
                {/* Company */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: { xs: 1.25, sm: 1.5 },
                        minWidth: 0,
                        flex: { sm: "1 1 180px" },
                    }}
                >
                    <Box
                        component="img"
                        src={ticket?.logoUrl ?? BusImage}
                        alt={ticket?.company_name}
                        sx={{
                            width: { xs: 40, md: 44 },
                            height: { xs: 40, md: 44 },
                            objectFit: "contain",
                            flexShrink: 0,
                        }}
                    />
                    <Box sx={{ minWidth: 0, flex: 1 }}>
                        <Typography
                            variant="subtitle1"
                            fontWeight="bold"
                            sx={{
                                fontSize: { xs: "0.95rem", md: "1rem" },
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }}
                            title={ticket?.company_name}
                        >
                            {ticket?.company_name}
                        </Typography>
                        <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{
                                fontSize: { xs: "0.8rem", md: "0.875rem" },
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            {ticket?.move_date?.replaceAll("-", "/")} - ساعت {ticket?.move_time}
                        </Typography>
                    </Box>
                </Box>

                {/* Route */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: { xs: 0.75, sm: 1 },
                        minWidth: 0,
                        flex: { sm: "1 1 auto" },
                        justifyContent: { xs: "flex-start", sm: "center" },
                    }}
                >
                    <Typography
                        variant="body1"
                        sx={{
                            fontSize: { xs: "0.78rem", sm: "0.9rem", md: "1rem" },
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: { xs: "40%", sm: "45%" },
                        }}
                        title={ticket?.origin?.name}
                    >
                        {ticket?.origin?.name}
                    </Typography>
                    <Divider sx={{ width: { xs: 100, sm: 24 }, flexShrink: 0 }} />
                    <Typography
                        variant="body1"
                        sx={{
                            fontSize: { xs: "0.78rem", sm: "0.9rem", md: "1rem" },
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: { xs: "40%", sm: "45%" },
                        }}
                        title={ticket?.destination?.name}
                    >
                        {ticket?.destination?.name}
                    </Typography>
                </Box>

                {/* Price + edit (same row on mobile too, so it doesn't feel orphaned) */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: { xs: "space-between", sm: "flex-end" },
                        gap: 1.5,
                        flex: { sm: "0 0 auto" },
                    }}
                >
                    <Typography
                        variant="subtitle1"
                        fontWeight="bold"
                        color="primary.main"
                        sx={{
                            fontSize: { xs: "0.85rem", sm: "0.95rem", md: "1rem" },
                            whiteSpace: "nowrap",
                        }}
                    >
                        {numberWithCommas(ticket?.price)} {t("currency")}
                    </Typography>

                    <Edit2 color="var(--primary-color)" cursor="pointer" onClick={onEditTicket} size={20} />
                </Box>
            </Box>
        </Card>
    );
}
